import React from 'react'
import { Field, useFormikContext } from 'formik'
import Select from 'components/Form/Select'
import TextInput from 'components/Form/TextInput'
import DatePicker from 'components/Form/DatePicker'

const InvoiceHeader = ({ customers, id }) => {
    const { values, errors, touched, setFieldValue } = useFormikContext()

    return (
        <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
            <Field name="customer">
                {({ field, form }) => {
                    console.log('Customer dropdown render:')
                    console.log('- field value:', field.value)
                    console.log('- form values.customer:', values?.customer)
                    console.log('- available customers:', customers)
                    // Removed problematic force-setting logic that was causing wrong customer selection
                    return (
                        <Select
                            options={customers}
                            label="Customer *"
                            placeholder="Select Customer"
                            name="customer"
                            className="md:col-span-3"
                            error={errors.customer && touched.customer}
                            message={errors.customer}
                            value={field.value || values?.customer || ''}
                            onChange={e => {
                                console.log('Customer dropdown changed to:', e.target.value)
                                form.setFieldValue(field.name, e.target.value)
                            }}
                        />
                    )
                }}
            </Field>
            <Field name="reference">
                {({ field, form }) => (
                    <TextInput
                        type="text"
                        className="md:col-span-3"
                        label="Reference"
                        name="reference"
                        placeholder="Optional reference"
                        error={errors.reference && touched.reference}
                        message={errors.reference}
                        value={values?.reference}
                        disabled={id && values.reference?.startsWith('MAESTRO-')}
                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                    />
                )}
            </Field>
            {id && values.reference?.startsWith('MAESTRO-') && (
                <div className="md:col-span-6 -mt-2 mb-2 text-xs text-blue-600">
                    This is a Maestro-created invoice. The reference cannot be changed.
                </div>
            )}
            <Field name="invoice_date">
                {({ field, form }) => (
                    <DatePicker
                        className="md:col-span-3"
                        label="Invoice Date *"
                        name="invoice_date"
                        error={errors.invoice_date && touched.invoice_date}
                        message={errors.invoice_date}
                        value={values?.invoice_date}
                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                    />
                )}
            </Field>
            <Field name="due_date">
                {({ field, form }) => (
                    <DatePicker
                        className="md:col-span-3"
                        label="Due Date"
                        name="due_date"
                        placeholder="Optional - Xero will use customer default"
                        error={errors.due_date && touched.due_date}
                        message={errors.due_date}
                        value={values?.due_date}
                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                    />
                )}
            </Field>
        </div>
    )
}

export default InvoiceHeader
